import React from 'react';
import { useState, useEffect, useRef } from "react";
import { useSelector } from 'react-redux';

import { getUserUrl } from '../../../redux/auth/auth-selectors';

// import axios from 'axios';
import Return from './return';
import Devices from './Preview_devices';
import Reticles from '../tools/create_section/Reticles';
import Export from './export';
import './preview_menu.scss';
import ProfileContent from "../../components/profile/ProfileContent";
import Tooltip from "../tooltip/Tooltip";
import defaultUserPhoto from '../../img/log-in-active.svg';
import { createUseStyles } from "react-jss";


const useStales = createUseStyles({
  userPhoto: {
    display: 'inline-block',
    width: 50,
    height: 50,
    borderRadius: '50%'
  },
});

export default function Menu({ activeTab, handlerReticleRename, onExportingTool, focus, blur, isFocused }) {
  const classes = useStales('');

  const [openUserAccount, setOpenUserAccount] = useState(false);
  const profPic = useSelector(getUserUrl);
  const profileBtn = useRef();
  const profileContent = useRef(null);

  useEffect(() => {
    const handleClick = e => {

      if (e.target === profileBtn.current) { setOpenUserAccount(!openUserAccount) }
    }

    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);


  // useEffect(() => {
  //   axios.get('/preview')
  //     .then(response => {
  //       setName(response.data.fileName)
  //     });
  // }, [fileName]);

  return (
    <section className='preview_menu-section'>
      <Reticles activeTab={activeTab} handlerReticleRename={handlerReticleRename} focus={focus} blur={blur} />
      <Devices activeTab={activeTab} focus={focus} blur={blur} isFocused={isFocused} />
      <div className='preview_menu-importing'>
        <Return />
        <Export onExportingTool={onExportingTool} activeTab={activeTab} />

        <Tooltip
          content={'Profile'}
          direction="bottom"
          dirStyle="profile"
        >
          <img ref={profileBtn}
            style={{ width: 46, height: 46 }} src={profPic ? profPic : defaultUserPhoto} alt='User avatar' className={classes.userPhoto} />
        </Tooltip>



        {openUserAccount ? (
          <ProfileContent openUserAccount={openUserAccount} setOpenUserAccount={setOpenUserAccount} />
        ) : null}
      </div>
    </section>
  );
}
